






import { Vue, Component, Prop } from "vue-property-decorator";
import Home from "@/views/Home.vue";
import { getLocale } from "@/services/woocommerceService";
import { easync } from "@/helpers/http";
import { currentUserStore, customizationStore } from "@/store/typed";
import { DEFAULT_LANG, STORE_URL, LANGUAGES } from "@/constants";
@Component({
  components: {
    Home,
  },
})
export default class App extends Vue {

  private langLoaded = false;

  @Prop() context: string;

  get showApp(){
    return this.langLoaded;
  }

  async mounted() {

    const referrer = document.referrer;
    let lang = DEFAULT_LANG;
    const candidateLang = referrer.replace(STORE_URL+"/", "").split('/')[0];
    if(LANGUAGES.includes(candidateLang)){
      lang = candidateLang;
    }
    this.langLoaded = true;
    customizationStore.setMode("2d");
    currentUserStore._setLang(lang);
    if (window.location.href != referrer) {
      currentUserStore._setReferrer(document.referrer);
    }
    this.$i18n.locale = lang;
  }
}
